import IState from '../state';

const setCurrentRecipe = (state: IState, { currentRecipe }: any): IState => ({
  ...state,
  currentRecipe,
});

export default setCurrentRecipe;
